"use strict";

var _defineProperty = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.find");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  :root {\n    --app-height: 100vh;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HideOn = exports.ShowOn = exports.maxMedia = exports.media = exports.customMediaQuery = exports.useResponsive = exports.BREAKPOINTS = exports.ResponsiveContextProvider = exports.ResponsiveContext = exports.ResponsiveType = void 0;

var lodash_1 = require("lodash");

var react_1 = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var hasWindow = typeof window !== 'undefined';
var RESIZE_DEBOUNCE = 250;
var AppHeightGlobal = (0, styled_components_1.createGlobalStyle)(_templateObject());
var ResponsiveType;

(function (ResponsiveType) {
  ResponsiveType[ResponsiveType["LessThan"] = 0] = "LessThan";
  ResponsiveType[ResponsiveType["GreaterThan"] = 1] = "GreaterThan";
  ResponsiveType[ResponsiveType["EqualTo"] = 2] = "EqualTo";
  ResponsiveType[ResponsiveType["NotEqualTo"] = 3] = "NotEqualTo";
})(ResponsiveType = exports.ResponsiveType || (exports.ResponsiveType = {}));

exports.ResponsiveContext = react_1["default"].createContext({
  width: hasWindow ? window.innerWidth : 0,
  height: hasWindow ? window.innerHeight : 0
});

var ResponsiveContextProvider = function ResponsiveContextProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useState)(hasWindow ? window.innerWidth : 0),
      _ref3 = _slicedToArray(_ref2, 2),
      width = _ref3[0],
      setWidth = _ref3[1];

  var _ref4 = (0, react_1.useState)(hasWindow ? window.innerHeight : 0),
      _ref5 = _slicedToArray(_ref4, 2),
      height = _ref5[0],
      setHeight = _ref5[1];

  (0, react_1.useEffect)(function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    document.documentElement.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
    var debounced = (0, lodash_1.debounce)(function () {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      document.documentElement.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
    }, RESIZE_DEBOUNCE);
    window.addEventListener('resize', debounced);
    return function () {
      return window.removeEventListener('resize', debounced);
    };
  }, []);
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(AppHeightGlobal, null), react_1["default"].createElement(exports.ResponsiveContext.Provider, {
    children: children,
    value: {
      width: width,
      height: height
    }
  }));
};

exports.ResponsiveContextProvider = ResponsiveContextProvider;

var calculateResponsiveResult = function calculateResponsiveResult(type, size, width) {
  switch (type) {
    case ResponsiveType.EqualTo:
      return width >= exports.BREAKPOINTS[size] && width <= (Object.values(exports.BREAKPOINTS).find(function (val) {
        return val > exports.BREAKPOINTS[size];
      }) || Infinity);

    case ResponsiveType.GreaterThan:
      return width >= exports.BREAKPOINTS[size];

    case ResponsiveType.LessThan:
      return width < exports.BREAKPOINTS[size];

    case ResponsiveType.NotEqualTo:
      return !(width >= exports.BREAKPOINTS[size] && width <= (Object.values(exports.BREAKPOINTS).find(function (val) {
        return val > exports.BREAKPOINTS[size];
      }) || Infinity));
  }
};

exports.BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};

var useResponsive = function useResponsive(type, size) {
  var _ref6 = (0, react_1.useState)(),
      _ref7 = _slicedToArray(_ref6, 2),
      result = _ref7[0],
      setResult = _ref7[1];

  var _ref8 = (0, react_1.useContext)(exports.ResponsiveContext),
      width = _ref8.width;

  (0, react_1.useEffect)(function () {
    var newResult = calculateResponsiveResult(type, size, width);

    if (newResult !== result) {
      setResult(newResult);
    }
  }, [width, setResult, result]);
  return result;
};

exports.useResponsive = useResponsive;

var customMediaQuery = function customMediaQuery(minMax, width) {
  return "@media (".concat(minMax, "-width: ").concat(width, "px)");
};

exports.customMediaQuery = customMediaQuery;
var breakpointKeys = Object.keys(exports.BREAKPOINTS);
exports.media = breakpointKeys.reduce(function (acc, label) {
  return Object.assign(Object.assign({}, acc), _defineProperty({}, label, (0, exports.customMediaQuery)('min', exports.BREAKPOINTS[label])));
}, {});
exports.maxMedia = breakpointKeys.reduce(function (acc, label) {
  return Object.assign(Object.assign({}, acc), _defineProperty({}, label, (0, exports.customMediaQuery)('max', exports.BREAKPOINTS[label])));
}, {});
exports.ShowOn = styled_components_1["default"].div(_templateObject2(), function (props) {
  return exports.media[props.size];
});
exports.HideOn = styled_components_1["default"].div(_templateObject3(), function (props) {
  return exports.media[props.size];
});